import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import Script from 'next/script';
import type { BirdeyeWidgetBlock } from '../types';
import styles from './BirdeyeWidget.module.css';
interface BirdeyeWidgetProps {
  block: BirdeyeWidgetBlock;
  blockId: string;
}

/**
 * Renders a Birdeye review widget. The widget JS injects review cards into the
 * matched container `id`. The shape matches the existing
 * `ExpertCtaStripBirdeyeConfig`, but here it's a standalone description block
 * (not part of the ExpertCtaStrip composite).
 */
export function BirdeyeWidget(t0) {
  const $ = _c(14);
  const {
    block,
    blockId
  } = t0;
  let t1;
  if ($[0] !== block.widgetId) {
    t1 = <div id={block.widgetId} className={styles.container} />;
    $[0] = block.widgetId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `birdeye-${block.widgetId}`;
  let t3;
  if ($[2] !== block.scriptSrc || $[3] !== t2) {
    t3 = <Script src={block.scriptSrc} strategy="lazyOnload" id={t2} />;
    $[2] = block.scriptSrc;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== block.attributionLink) {
    t4 = block.attributionLink ? <p className={styles.attribution}><a href={block.attributionLink.href} target="_blank" rel="noopener noreferrer">{block.attributionLink.label}</a></p> : null;
    $[5] = block.attributionLink;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== block.scriptSrc || $[8] !== block.widgetId || $[9] !== blockId || $[10] !== t1 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={styles.wrapper} data-cms-block-id={blockId} data-cms-field="birdeyeWidget" data-birdeye-script-src={block.scriptSrc} data-birdeye-widget-id={block.widgetId}>{t1}{t3}{t4}</div>;
    $[7] = block.scriptSrc;
    $[8] = block.widgetId;
    $[9] = blockId;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}